import { useCallback } from 'react';
import { ESubscriptionLimitType } from 'shared/common/packages/EarlyAccessPaywall/shared/types/context';
import { useContext as useEarlyAccessPaywallContext } from 'shared/common/packages/EarlyAccessPaywall/shared/utils/useContext';

export interface IUseCheckContactsAccessParams {
  offerId: number;
  limitType?: ESubscriptionLimitType;
  silent?: boolean;
}

export function useCheckContactsAccess() {
  const earlyAccessPaywallContext = useEarlyAccessPaywallContext();

  const checkContactsAccess = useCallback(
    async ({
      offerId,
      limitType = ESubscriptionLimitType.PhoneNumber,
    }: IUseCheckContactsAccessParams): Promise<boolean> => {
      try {
        return await earlyAccessPaywallContext.checkContactsAccess({ offerId, limitType });
      } catch (error) {
        return false;
      }
    },
    [earlyAccessPaywallContext],
  );

  return { checkContactsAccess };
}
